import { Instagram, Youtube } from "lucide-react";
import { INSTAGRAM_URL, INSTAGRAM_QR, YOUTUBE_URL, YOUTUBE_QR } from "../lib/site";

export default function SocialRail() {
  const items = [
    { label: "Instagram", href: INSTAGRAM_URL, qr: INSTAGRAM_QR, Icon: Instagram, tid: "social-instagram", handle: "@bhoomizaorganics" },
    { label: "YouTube", href: YOUTUBE_URL, qr: YOUTUBE_QR, Icon: Youtube, tid: "social-youtube", handle: "Bhoomiza Organics" },
  ];
  return (
    <aside className="social-rail" aria-label="Follow us" data-testid="social-rail">
      {items.map(({ label, href, qr, Icon, tid, handle }) => (
        <div className="social-item" key={label}>
          <a href={href} target="_blank" rel="noopener noreferrer" className="social-btn" data-testid={tid} aria-label={`Open ${label}`}>
            <Icon size={18} strokeWidth={1.8} />
            <span className="social-label">{label}</span>
          </a>
          <div className="qr-popover" role="tooltip" data-testid={`${tid}-qr`}>
            <img src={qr} alt={`${label} QR code — scan to follow Bhoomiza Organics`} loading="lazy" />
            <div className="qr-caption">
              <span>Scan to follow</span>
              <strong>{handle}</strong>
            </div>
            <div className="qr-tail" aria-hidden="true" />
          </div>
        </div>
      ))}
    </aside>
  );
}
